// client/src/services/reliableSessionService.js
//
// Fetches/clears the server-side mirror of the "Current Session" call cards.
// The backend keeps this snapshot in Redis (same shape as the browser's
// localStorage `bzct_reliable_calls_v1`) from the 3CX events it receives even
// while the browser is disconnected. The FE reconciles it on login / refresh /
// reconnect so a card stuck on Ringing/Connected heals to its true Ended state.

import { fetchWithAuth } from './apiClient';

const getApiUrl = () =>
  window.location.hostname === 'localhost'
    ? 'http://localhost:7080/api'
    : `/api`;

export const reliableSessionService = {
  /**
   * GET the reliable call-card snapshot for a user.
   * @returns {Promise<{calls: Array}|null>} snapshot or null on failure
   */
  async fetchSnapshot(username) {
    if (!username) return null;
    try {
      const response = await fetchWithAuth(`${getApiUrl()}/reliable-session/${username}`);
      const data = await response.json();
      return data?.snapshot || null;
    } catch (error) {
      console.warn('reliableSessionService.fetchSnapshot failed:', error?.message);
      return null;
    }
  },

  /**
   * DELETE the server-side snapshot (best-effort; backs "Clear Session").
   */
  async clearSnapshot(username) {
    if (!username) return;
    try {
      await fetchWithAuth(`${getApiUrl()}/reliable-session/${username}`, {
        method: 'DELETE',
      });
    } catch (error) {
      console.warn('reliableSessionService.clearSnapshot failed:', error?.message);
    }
  },
};
